export default "__VITE_ASSET__4wbf0Vhx__"